const getCarType = (client, id) => client.request({
  url: `/v1/application/carTypes/${id}`,
  method: 'get',
});

const getCarTypes = (client, params) => client.request({
  url: '/v1/application/carTypes',
  method: 'get',
  params,
});

const getDeposit = (client, params) => client.request({
  url: '/v1/application/carDeposit',
  method: 'get',
  params,
});

const getCarTypesByCarClass = (client, params) => client.request({
  url: '/v1/application/carTypesByCarClass',
  method: 'get',
  params,
});

export default {
  getCarType,
  getCarTypes,
  getDeposit,
  getCarTypesByCarClass,
};
